/* global axios */
import ApiClient from './ApiClient';

class SocialCommentsAPI extends ApiClient {
  constructor() {
    super('social_comments', { accountScoped: true });
  }

  getByPost(socialPostId, { page = 1, status, rootOnly } = {}) {
    const params = { social_post_id: socialPostId, page };
    if (status) params.status = status;
    if (rootOnly) params.root_only = 'true';
    return axios.get(this.url, { params });
  }

  reply(id, content) {
    return axios.post(`${this.url}/${id}/reply`, { content });
  }

  like(id) {
    return axios.post(`${this.url}/${id}/like`);
  }

  hide(id) {
    return axios.post(`${this.url}/${id}/hide`);
  }

  openDm(id, message) {
    return axios.post(`${this.url}/${id}/open_dm`, { message });
  }

  delete(id) {
    return axios.delete(`${this.url}/${id}`);
  }
}

export default new SocialCommentsAPI();
